const keyMirror = require('keymirror');
import { shareCommunity, requestProjectDetail, loadProject as loadProjectAPI } from '../lib/http';

import { setProjectTitle } from './project-title';


const Types = keyMirror({
    SHOW_SAVE_DIALOG: null,
    SHOW_SHARE_DIALOG: null,
    SET_SHARE_COVERFILE: null,
    SET_SHARE_KEYBOARDTYPE: null,
    SET_SHARE_PROJECT_DESCRIPTION: null,
    SET_SHARE_PROJECT_FILE: null,
    SET_SHARE_ALL: null,
    SET_NEED_SHARE: null
})

const initialState = {
    saveDialog: false,
    shareDialog: false,
    coverFile: '',
    keyboardType: 0,
    projectDescription: '',
    projectFile: '',
    needShare: false
}

const reducer = (state, action) => {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case Types.SET_NEED_SHARE:
            return {
                ...state,
                needShare: action.needShare
            }
        case Types.SET_SHARE_COVERFILE:
            return {
                ...state,
                coverFile: action.shareInfo
            };
        case Types.SET_SHARE_KEYBOARDTYPE:
            return {
                ...state,
                keyboardType: action.shareInfo
            };
        case Types.SET_SHARE_PROJECT_DESCRIPTION:
            return {
                ...state,
                projectDescription: action.shareInfo
            }
        case Types.SET_SHARE_PROJECT_FILE:
            return {
                ...state,
                projectFile: action.shareInfo
            };
        case Types.SET_SHARE_ALL:
            return {
                ...state,
                ...action.shareInfo
            };
        case Types.SHOW_SAVE_DIALOG:
            return {
                ...state,
                saveDialog: action.show
            }
        case Types.SHOW_SHARE_DIALOG:
            return {
                ...state,
                shareDialog: action.show
            }
        default:
            return state;
    }
}

const setNeedShare = boolean => ({
    type: 'SET_NEED_SHARE',
    needShare: boolean
})

const setShareWorkInfo = (key, value) => {
    const upperCaseKey = key.toUpperCase();
    return {
        type: `SET_SHARE_${upperCaseKey}`,
        shareInfo: value
    }
}

const showSaveDialog = (boolean) => ({
    type: 'SHOW_SAVE_DIALOG',
    show: boolean
})

const showShareDialog = (boolean) => ({
    type: 'SHOW_SHARE_DIALOG',
    show: boolean
})

/* Todo：更新／保存／分享／资源加载 状态跟踪 */

const shareToCommunity = (params, callback) => () => shareCommunity(params).then(res => callback(res.data.success))

const fetchWorkSource = id => dispatch =>
    requestProjectDetail({ customerProjectId: id }).then(res => {
        const { success, data } = res.data;
        if (!success) return false;
        const { projectName, keyboardType, projectDescription, coverUrl, projectUrl } = data;
        dispatch(setProjectTitle(projectName));
        dispatch(setShareWorkInfo('all', {
            keyboardType,
            projectDescription,
            coverUrl
        }));
        return loadProjectAPI(projectUrl)
    })

export {
    reducer as default,
    initialState as shareWorkInitialState,
    setShareWorkInfo,
    showSaveDialog,
    showShareDialog,
    shareToCommunity,
    fetchWorkSource,
    setNeedShare
}
